module.exports = __webpack_public_path__ + "static/DSC_9462_1-a28ac7ce5f2968145575cf75c15502ed.jpg";